'use client';

import React, { useState } from 'react';
import Image from 'next/image';

type PartnerLogoProps = {
  domain: string;
  name: string;
  size?: 'sm' | 'md';
  logoSrc?: string;
  logoWide?: boolean;
};

export function PartnerLogo({ domain, name, size = 'md', logoSrc, logoWide }: PartnerLogoProps) {
  const [failed, setFailed] = useState(false);
  const src = logoSrc ?? `https://icons.duckduckgo.com/ip3/${encodeURIComponent(domain)}.ico`;
  const dim = size === 'sm' ? 28 : 36;
  const className =
    logoWide && logoSrc
      ? size === 'sm'
        ? 'h-7 w-auto max-w-[88px] object-contain shrink-0'
        : 'h-9 w-auto max-w-[110px] object-contain shrink-0'
      : size === 'sm'
        ? 'h-7 w-7 rounded-md object-contain bg-white border border-slate-200 dark:border-slate-600 shrink-0 shadow-sm'
        : 'h-9 w-9 rounded-lg object-contain bg-white border border-slate-200 shrink-0 shadow-sm';

  if (failed) {
    return (
      <div
        className={
          size === 'sm'
            ? 'h-7 w-7 rounded-md bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-600 flex items-center justify-center text-[9px] font-bold text-[#1B3A5C] dark:text-sky-300 shrink-0'
            : 'h-9 w-9 rounded-lg bg-slate-100 border border-slate-200 flex items-center justify-center text-[10px] font-bold text-[#1B3A5C] shrink-0'
        }
        aria-hidden
      >
        {name.slice(0, 2).toUpperCase()}
      </div>
    );
  }

  const image = (
    <Image
      src={src}
      alt=""
      width={logoWide ? 110 : dim}
      height={dim}
      className={className}
      unoptimized={!logoSrc}
      onError={() => setFailed(true)}
    />
  );

  if (logoWide && logoSrc) {
    return (
      <div className="rounded-md bg-[#0a0f14] px-2 py-1 shrink-0" aria-hidden>
        {image}
      </div>
    );
  }

  return image;
}
